<template>
    <bill-shell>
        <section class="py-5 pb-3 bg-white">
            <ViewTokenContent />
        </section>
    </bill-shell>
</template>

<script>
import BillShell from "../../bill-shell.vue";
import ViewTokenContent from "./ViewTokenContent.vue";

export default {
    name: "ViewTokenLayout",
    components: {
        BillShell,
        ViewTokenContent,
    },
};
</script>
